import React from "react";

// components
import { Divider, Box } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

// css
import { colors } from "common/styles/configLayout.js";


const LicensesCard = ({rowData, handleRemoveItem}) => {

    return (
        <Box 
            className="PriceListClubsContainer"
            display="grid" 
            gridTemplateColumns="
                40px 
                minmax(150px, 200px) 
                minmax(180px, 250px) 
                minmax(120px, 180px) 
                minmax(80px, 120px) 
                minmax(100px, 150px) 
                40px"
            width={"100%"} 
            mt="0.5rem" mb="0.8rem"
            style={{
            }}
            >
            {/* Hlavička tabuľky */}
            <Box
                display="contents"
                style={{
                    fontWeight: 'bold',
                    fontSize: '0.8rem',
                }}
            >
                <Typography style={{ textAlign: 'center' }}></Typography>
                <Typography>Meno</Typography>
                <Typography>Klub</Typography>
                <Typography>Funkcia</Typography>
                <Typography>Rok</Typography>
                <Typography>Kategória</Typography>
                <Typography></Typography>
            </Box>

            <Box
                style={{
                    gridColumn: '1 / -1',
                    height: '2px',
                    backgroundColor: colors.strokeColor,
                    marginTop: '0.5rem',
                }}
            />

            {/* Riadky tabuľky */}
            {rowData?.map((item, index) => (
                <>
                    <Box 
                        key={index}
                        display="contents"
                        mt="0.5rem"
                        style={{
                            backgroundColor: index % 2 === 0 ? 'transparent' : 'rgba(0, 0, 0, 0.05)',  
                            color: colors.textBody,
                            padding: "8px 0",
                            whiteSpace: 'wrap',
                        }}
                    >
                        <Typography 
                            style={{ 
                                textAlign: 'center',
                                fontSize: '0.8rem',
                                paddingRight: '0.5rem',
                            }}
                        >
                            {index + 1}
                        </Typography>
                        <Typography
                            style={{
                                fontSize: '0.8rem',
                                paddingRight: '0.5rem',
                            }}
                        >
                            {item.member}
                            </Typography>
                        <Typography
                            style={{
                                fontSize: '0.8rem',
                                paddingRight: '0.5rem',
                            }}
                        >
                            {item.club}
                        </Typography>
                        <Typography
                            style={{
                                fontSize: '0.8rem',
                                paddingRight: '0.5rem',
                            }}
                        >
                            {item.function}
                        </Typography>
                        <Typography
                            style={{
                                fontSize: '0.8rem',
                                paddingRight: '0.5rem',
                            }}
                        >
                            {item.year}
                        </Typography>
                        <Typography
                            style={{
                                fontSize: '0.8rem',
                                paddingRight: '0.5rem',
                            }}
                        >
                            {item.categories}
                        </Typography>
                        <Typography
                            className="crossIconDelete"
                            style={{
                            cursor: 'pointer',
                            textAlign: 'center',
                            // color: '#999',
                            }}
                            onClick={() => handleRemoveItem(item.id)}
                        >
                            ✖
                        </Typography>
                    </Box>

                    <Box
                        style={{
                        gridColumn: '1 / -1',
                        height: '1px',
                        backgroundColor: colors.strokeColor,
                        }}
                    />
                </>
            ))}
        </Box>
    )
};

export default LicensesCard;